module.exports = __webpack_public_path__ + "static/media/img-1.2b2874be.jpg";